import mapa from "./mapa";
import preguntasFrecuentes from "./preguntas-frecuentes";
import video from "./video";
import portada from "./portada";
import blog from "./blog";
import cabecera from "./cabecera";

const bloques = (actualizar: () => void) => {
    mapa();
    preguntasFrecuentes();
    video();
    portada();
    blog(actualizar);
    cabecera();
}

export default bloques;